/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import Sidebar from 'components/layout/Sidebar/Sidebar';
import {
  FilterSection, FilterField, FilterActions, countActiveFilters,
} from 'components/layout/Sidebar/Filter';
import {
  CustomDatepicker as Datepicker,
  Select,
  CreatableSelect,
} from 'components/common';

import * as styles from './Sidebar.styles';

const BatchSidebar = ({
  search,
  programOptions,
  filterCondition,
  setFilterCondition,
  handleSubmit,
  handleReset,
}) => {
  const handleMultiValueChange = (d, name) => {
    setFilterCondition((prevState) => ({
      ...prevState,
      [name]: d,
    }));
  };

  const handleChange = (e) => {
    setFilterCondition((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDateChange = (e, name) => {
    setFilterCondition((prevState) => ({
      ...prevState,
      [name]: e,
    }));
  };

  return (
    <Sidebar search={search} activeCount={countActiveFilters(filterCondition)}>
      <div css={styles.filterConditionsContainerStyles}>
        <FilterSection title="Dates">
          <FilterField label="registration date">
            <Datepicker
              portalId="filter-panel-popover"
              containerStyles={styles.datepickerContainerStyles}
              startDate={filterCondition.registrationDate[0]}
              endDate={filterCondition.registrationDate[1]}
              setDateRange={(e) => handleDateChange(e, 'registrationDate')}
              placeholder="registration date"
            />
          </FilterField>
          <FilterField label="class start date">
            <Datepicker
              portalId="filter-panel-popover"
              containerStyles={styles.datepickerContainerStyles}
              startDate={filterCondition.classDate[0]}
              endDate={filterCondition.classDate[1]}
              setDateRange={(e) => handleDateChange(e, 'classDate')}
              placeholder="class start date"
            />
          </FilterField>
          <FilterField label="graduation date">
            <Datepicker
              portalId="filter-panel-popover"
              containerStyles={styles.datepickerContainerStyles}
              startDate={filterCondition.graduationDate[0]}
              endDate={filterCondition.graduationDate[1]}
              setDateRange={(e) => handleDateChange(e, 'graduationDate')}
              placeholder="graduation date"
            />
          </FilterField>
        </FilterSection>
        <FilterSection title="Program">
          <FilterField label="registration status">
            <Select
              containerStyles={styles.selectContainerStyles}
              name="registrationStatus"
              options={[
                {
                  label: 'open',
                  value: 'open',
                },
                {
                  label: 'close',
                  value: 'close',
                },
                {
                  label: 'upcoming',
                  value: 'upcoming',
                },
              ]}
              placeholder="registration status"
              onChange={handleChange}
              value={filterCondition.registrationStatus}
            />
          </FilterField>
          <FilterField label="programs">
            <CreatableSelect
              portalMenu
              containerStyles={styles.select2ContainerStyles}
              options={programOptions}
              placeholder="programs"
              value={filterCondition.programs}
              onChange={(d) => handleMultiValueChange(d, 'programs')}
            />
          </FilterField>
        </FilterSection>
      </div>
      <FilterActions onApply={handleSubmit} onReset={handleReset} />
    </Sidebar>
  );
};

BatchSidebar.propTypes = {
  search: Sidebar.propTypes.search,
  programOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filterCondition: PropTypes.shape({
    registrationDate: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    classDate: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    registrationStatus: PropTypes.string,
    programs: PropTypes.arrayOf(PropTypes.shape({})),
    graduationDate: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  }).isRequired,
  setFilterCondition: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
};

BatchSidebar.defaultProps = {
  search: null,
  // startDate: null,
  // endDate: null,
};

export default BatchSidebar;
